import React from 'react';
import MarketServiceGenericService from "./MarketServiceGenericService";

function WeeklyReleasabilityService() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/weeklyReleasability/`;
    return (<MarketServiceGenericService
        endpointUrl={endpointUrl}
        pageName={"Weekly Releasability Service"}
    />);
}

export default WeeklyReleasabilityService;
